import type { FunctionComponent } from 'react';
import { useMatch } from 'react-router';
import { Box } from '@mantine/core';
import { useTranslation } from 'i18n';

import { POS_MENU_SETTINGS_ROUTE } from 'constants/path';
import NotificationWrapper from 'primitives/NotificationWrapper/NotificationWrapper';
import { POS_LOGOS } from './constants';
import { useConnectedPos } from './useConnectedPos';

const NS = 'posMenuSettings';
const LOGO_SIZE = 30;

export const PosImportedBanner: FunctionComponent = () => {
  const { t } = useTranslation(NS);
  const isPosMenuSettingsRoute = !!useMatch(POS_MENU_SETTINGS_ROUTE);
  const posResource = useConnectedPos();

  if (!isPosMenuSettingsRoute || !posResource) return null;

  const Logo = POS_LOGOS[posResource.type];

  return (
    <Box mb="xs" data-testid="pos-imported-banner">
      <NotificationWrapper
        variant="neutral"
        size="compact"
        icon={
          Logo && (
            <Logo
              width={LOGO_SIZE}
              height={LOGO_SIZE}
              role="img"
              aria-label={`${posResource.display_name} logo`}
            />
          )
        }
      >
        {t('PosImportedBanner.message', { posName: posResource.display_name })}
      </NotificationWrapper>
    </Box>
  );
};
